"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
var jsx_runtime_1 = require("preact/jsx-runtime");
var Loading = function () {
    return (0, jsx_runtime_1.jsx)("div", { class: "artajs__modal__loading" });
};
exports.Loading = Loading;
